import { Container } from '@mui/material'
import { GridBreakpoint } from '../../interfaces/IGridSettings'
import { ReactNode } from 'react'

interface CustomContainerProps {
  children: ReactNode
  gridWidth?: GridBreakpoint
  maxWidth?: 'xl' | 'lg' | 'md' | 'sm' | 'xs' | false
}

export function CustomContainer({ children, gridWidth, maxWidth }: CustomContainerProps) {
  return (
    <Container sx={{ mt: 2, mb: 20, maxWidth: gridWidth }} maxWidth={maxWidth ? maxWidth : false}>
      {children}
    </Container>
  )
}
